import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { Environment } from "../_generated";

export default function EnvironmentsBulkUpdateDialog(props: {
  open: boolean;
  environments: Environment[];
  servicePk: Number | undefined;
  onCancel: () => any;
  onConfirm: (
    environmentsToUpdate: Environment[],
    servicePk: Number | undefined
  ) => any;
}) {
  const [selection, setSelection] = useState(
    Object.fromEntries(
      props.environments.map((environment) => [environment.pk, false])
    )
  );

  function selectEnvironment(
    environment: Environment,
    shouldBeSelected: boolean
  ) {
    const key = environment.pk!.toString();
    setSelection({ ...selection, [key]: shouldBeSelected });
  }

  function getSelectedEnvironments() {
    return props.environments.filter((env: Environment) => selection[env.pk!]);
  }

  return (
    <Dialog open={props.open}>
      <DialogTitle>Update Environments?</DialogTitle>
      <DialogContent>
        {props.environments.map((environment) => (
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) =>
                  selectEnvironment(environment, e.target.checked)
                }
              />
            }
            label={environment.name}
          />
        ))}
        <p>
          Infrastructure will be updated to the latest version. If you created
          new services, the needed infrastructure for them will be provisioned.
          If you deleted some services, their supporting infrastructure will be
          destroyed.
        </p>
        <p>Or you can always update environments one by one later</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel}>Later</Button>
        <Button
          variant="contained"
          color="primary"
          disabled={getSelectedEnvironments().length === 0}
          onClick={() => {
            props.onConfirm(getSelectedEnvironments(), props.servicePk);
            props.environments.forEach((env) => selectEnvironment(env, false));
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
